import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";

const WorkOrderAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  // Get current pathname without query params for comparison
  const pathname = location.pathname;
  const pathWithoutPrefix = pathname.replace(process.env.PUBLIC_URL || "", "");

  // Helper function to check if a route is active
  const isActive = (route: string) => {
    const routePath = route.replace(process.env.PUBLIC_URL || "", "");
    // Exact match
    if (pathWithoutPrefix === routePath) return true;
    // For view pages with IDs, highlight the corresponding list/view page
    if (
      routePath === "/view-work-orders" &&
      pathWithoutPrefix.startsWith("/work-order-view/")
    )
      return true;
    if (
      routePath === "/work-order-creation" &&
      pathWithoutPrefix.startsWith("/work-order-creation")
    )
      return true;
    return false;
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Order</span>
            <span className="sub-text">
              Manage work order processes and contractor assignments
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/work-order-creation`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-order-creation${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>New Work Order</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/work-order-approvals`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-order-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li
            className={
              isActive(
                `${process.env.PUBLIC_URL}/work-order-contractor-approvals`
              )
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/work-order-contractor-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-thumb" />
              <span>Work Order Amendment</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/Finalized-Work-Orders`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/Finalized-Work-Orders${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="users" />
              <span>Finalized Work Orders</span>
            </Link>
          </li>
          <li
            className={
              isActive(`${process.env.PUBLIC_URL}/view-work-orders`)
                ? "active"
                : ""
            }
          >
            <Link
              to={`${process.env.PUBLIC_URL}/view-work-orders${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="activity" />
              <span>View All Work Orders</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkOrderAside;
